import axios from 'axios'
// import { MessageBox, Message } from 'element-ui'
// import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000 * 60 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    //console.info('request interceptor', config)
    config.url = `/api/m${config.url}`
    config.headers['lshoot-qupaipai-hkm-account-token'] = getToken()

    // if (store.getters.token) {
    //   // let each request carry token --['X-Token'] as a custom key.
    //   // please modify it according to the actual situation.
    //   config.headers['lshoot-qupaipai-hk-account-token'] = getToken()
    //   config.headers['lshoot-qupaipai-hk-account-loginRoleType'] = window.localStorage.loginRoleType || '1'
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code.
   */
  response => {
    // console.info('response interceptor->response', response)
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 20000) {

    // // 普通异常，直接返回
    // if (res.code === -1) {
    //   return res
    // }

    // 其他异常，如授权认证异常、服务器异常等
    if (res.code < 0) {
      // Message({
      //   message: res.msg || 'error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      res.msg = res.msg || 'error'
/*
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
*/
      return Promise.reject(res)
    } else {
      return res
    }
  },
  error => {
    // console.log('err' + error) // for debug
    const { response } = error
    //console.info('response interceptor->response', response)
    const { code, msg } = response.data
    let errMsg = error.message
    if (code < 0) {
      errMsg = msg
    }
    if (response.status === 401) {
      errMsg = `${msg}，请刷新页面`
      window.location.href = '/user/login'
    } else if (response.status === 500) {
      errMsg = `服务器返回异常：${msg}`
    }
    // if (errMsg !== '') {
    //   Message({
    //     message: errMsg,
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    // }
    console.info('request error', error, errMsg)
    if (code && code < 0) {
      return Promise.reject(response.data);
    }
    else {
      return Promise.reject(error);
    }
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js